// extracted by mini-css-extract-plugin
export var circle = "_dp-1";
export var exitConfirmationModal = "_dp-5";
export var iframe = "_dp-0";
export var offline = "_dp-3";
export var online = "_dp-2";
export var workstationSelectError = "_dp-4";